import { render, staticRenderFns } from "./EditFinishButton.vue?vue&type=template&id=bdacad18&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditFinishButton.vue"
export default component.exports